import { createContext, useContext, type ReactNode } from 'react'

/** Leaving the admin site (S-06 launch): `window.location.assign`, or a test's spy. */
export type Assign = (href: string) => void

const Ctx = createContext<{ assign: Assign; clinicOrigin: string } | null>(null)

export function ExternalNavProvider({
  assign,
  clinicOrigin,
  children,
}: {
  assign: Assign
  clinicOrigin: string
  children: ReactNode
}) {
  return <Ctx.Provider value={{ assign, clinicOrigin }}>{children}</Ctx.Provider>
}

export function useExternalNav(): { assign: Assign; clinicOrigin: string } {
  const value = useContext(Ctx)
  if (!value) throw new Error('useExternalNav: no ExternalNavProvider')
  return value
}
